import Paths, { openRoute } from "../../../router";

const { getConnectToTableURL } = require("../../../routes");

export class TableWebsocket
{

    constructor(tableCode, playerKey, history, onMessage)
    {
        this._onMessage = onMessage
        this._history = history
        this._tableCode = tableCode
        this._playerKey = playerKey
        this._retryCount = 0
        this._wasRetryDialogShown = false
        this._connected = false

        this._connectWS()

        this.send = this._send.bind(this)

        this._sendQueue = []
    }

    _send(inMessage)
    {
        if (inMessage && inMessage.toJS) {
            inMessage = inMessage.toJS()
        }
        if (this._connected) {
            this._ws.send(JSON.stringify(inMessage))
        } else {
            this._sendQueue.push(JSON.stringify(inMessage))
        }
    }

    _connectWS()
    {
        this._ws = new WebSocket(getConnectToTableURL(this._tableCode, this._playerKey))

        this._ws.onopen = ev => {
            this._retryCount = 0;
            console.log("WS opened")
            this._connected = true

            if (this._sendQueue) {
                this._sendQueue.forEach(msg => this._ws.send(msg))
                this._sendQueue = []
            }
        }

        this._ws.onmessage = ev => this._onMessage(JSON.parse(ev.data))
        this._ws.onclose = this._onClose.bind(this)
        this._ws.onerror = this._onClose.bind(this)
    }

    _onClose(info)
    {
        this._connected = false
        if (this._retryCount < 5)
        {
            this._retryCount++;
            console.log(info, " -- -- > Reconnect attempt no. " + this._retryCount)
            this._connectWS()
        }
        else if (!this._wasRetryDialogShown)
        {
            this._wasRetryDialogShown = true
            console.log("Reconnection failed")
            getDialog().show({
                content: Messages("table.error.connection-failed"),
                buttons: [
                    {
                        text: Messages("table.error.connection-retry"),
                        onClick: () => {
                            this._retryCount = 0;
                            this._wasRetryDialogShown = false
                            this._connectWS()
                        }
                    },
                    {
                        text: Messages("app.go-to-start"),
                        onClick: () => openRoute(this._history, Paths._PATH)
                    }
                ]
            })
        }
    }

}